import * as actionTypes from "../Actions/actionTypes";

const lodash = require("lodash");

export const defaultRoles = [
  { role: "coder", name: "Coder", plural: "Full-time Equivalent Coders", required: false },
  { role: "analyst", name: "Data Analyst", plural: "Data Analysts", required: false },
  { role: "manager", name: "Manager", plural: "Managers", required: false },
  { role: "qualitySpecialist", name: "Data Quality Specialist", plural: "Data Quality Specialists" },
  {
    role: "applicationCoordinator",
    name: "System Application Coordinator",
    plural: "System Application Coordinators",
  },
  { role: "codingDirector", name: "Coding Director", plural: "Coding Directors" },
  { role: "codingCoordinator", name: "Coding Coordinator", plural: "Coding Coordinators" },
  { role: "projectCoordinator", name: "Project Coordinator", plural: "Project Coordinators" },
  { role: "supervisor", name: "Supervisor", plural: "Supervisors" },
  { role: "dataEntry", name: "Data Entry Clerk", plural: "Data Entry Clerks" },
  { role: "collegeInstructor", name: "College Instructor", plural: "College Instructors" },
  { role: "provinceTrainer", name: "Provincial Trainer", plural: "Trainers from the Province" },
];

const initialState = {
  retrainCostDetails: {
    roles: defaultRoles,
  },
  prodLossDetails: {
    "coding-time-a": "13",
    "coding-time-b": "10",
  },
  systemCostDetails: {},
  costAdjustDetails: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_RETRAIN_COST_DETAIL:
      return { ...state, retrainCostDetails: action.value };

    case actionTypes.SET_RETRAIN_COMMON_ATTR:
      const retrainCostDetails = { ...state.retrainCostDetails, ...action.obj };
      return { ...state, retrainCostDetails };

    case actionTypes.SET_RETRAIN_COST_FOR_ROLE_ATTR:
      const roles = [...lodash.get(state.retrainCostDetails, "roles")];
      const roleStr = action.obj.role;
      const attr = action.obj.attr;
      const value = action.obj.value;
      let roleObj = roles.find((item) => item.role === roleStr);

      if (roleObj) {
        //update an existing entry
        roleObj[attr] = value;
      } else {
        //create a new entry
        roleObj = { role: roleStr, [attr]: value };
        roles.push(roleObj);
      }

      return {
        ...state,
        retrainCostDetails: { ...state.retrainCostDetails, roles },
      };

    case actionTypes.SET_PROD_LOSS:
      return { ...state, prodLossDetails: action.value };

    case actionTypes.SET_PROD_LOSS_ATTR:
      return { ...state, prodLossDetails: { ...state.prodLossDetails, ...action.obj } };

    case actionTypes.SET_SYSTEM_COST:
      return { ...state, systemCostDetails: action.value };

    case actionTypes.SET_SYSTEM_COST_ATTR:
      return { ...state, systemCostDetails: { ...state.systemCostDetails, ...action.obj } };

    case actionTypes.SET_COST_ADJUST:
      return { ...state, costAdjustDetails: action.value };

    case actionTypes.SET_COST_ADJUST_ATTR:
      return { ...state, costAdjustDetails: { ...state.costAdjustDetails, ...action.obj } };

    case actionTypes.CLEAR_COSTS:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
